import { useState, useEffect, useCallback } from "react";
import { apiService } from "../api/services/apiService";
import type { FAQ } from "../types";

export const useFaqs = () => {
  const [faqs, setFaqs] = useState<FAQ[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchFaqs = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await apiService.getFaqs();
      setFaqs(data);
    } catch (err: any) {
      console.error(err);
      setError(err.message || "Failed to fetch FAQs");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchFaqs();
  }, [fetchFaqs]);

  return { faqs, loading, error, refresh: fetchFaqs };
};
